import { render, staticRenderFns } from "./PefDetailsPage.vue?vue&type=template&id=7bfc4f30&"
import script from "./PefDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PefDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports